const r = "_header_3m6xr_1", t = "_withDots_3m6xr_10", n = "_isWrapping_3m6xr_13", s = "_btnWrapper_3m6xr_18", e = "_mainDetails_3m6xr_21", a = "_rolesContainer_3m6xr_26", o = "_dot_3m6xr_34", _ = "_addressContainer_3m6xr_37", i = {
  header: r,
  withDots: t,
  isWrapping: n,
  btnWrapper: s,
  mainDetails: e,
  rolesContainer: a,
  dot: o,
  addressContainer: _
};
export {
  _ as addressContainer,
  s as btnWrapper,
  i as default,
  o as dot,
  r as header,
  n as isWrapping,
  e as mainDetails,
  a as rolesContainer,
  t as withDots
};
//# sourceMappingURL=index.es5478.js.map
